/**
* Jump Link Banner JS
* -----------------------------------------------------------------------------
*
* All the JS for the Jump Link Banner component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
( function( app ) {
  const COMPONENT = {

    className: 'jump-link-banner',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      const dropdownButtonText = document.querySelector( '.dropdown-button-text' );
      const dropdownLinks = document.querySelectorAll( '#jump-link-banner-dropdown a' );

      if ( dropdownButtonText ) {
        dropdownLinks.forEach( function( link ) {
          link.addEventListener( 'click', function() {
            dropdownButtonText.innerText = link.innerText.trim();
          } );
        } );
      }

      const jumpLinkBanner = document.querySelector( '.jump-link-banner' );
      const jumpLinkContainer = document.querySelector( '.jump-link-container' );

      const publishBarHeight = function() {
        $( ':root' ).css( '--jumpLinkBarHeight', `${Math.ceil( jumpLinkContainer.getBoundingClientRect().height )}px` );
      };

      publishBarHeight();
      $( window ).on( 'resize', publishBarHeight );

      let topOffset = $( '.navbar' ).outerHeight() + jumpLinkContainer.offsetHeight;
      if ( $( '#wpadminbar' ).length > 0 ) {
        topOffset += $( '#wpadminbar' ).outerHeight();
      }

      window.addEventListener( 'scroll', function() {
        if ( window.scrollY + topOffset >= jumpLinkBanner.offsetTop + jumpLinkBanner.offsetHeight ) {
          jumpLinkContainer.classList.add( 'fixed-banner' );
        } else {
          jumpLinkContainer.classList.remove( 'fixed-banner' );
        }
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'jump-link-banner', COMPONENT );
} )( app );
